
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.333 11.368c0 1.504-.453 2.906-1.2 4.144l-1.64-1.554c.36-.783.574-1.655.574-2.59h2.266zM16 11.57L8 4.017v-.228C8 1.693 9.787 0 12 0s4 1.693 4 3.79v7.78zM1.693 1.263L24 22.396 22.307 24l-5.587-5.293a9.712 9.712 0 01-3.387 1.15V24h-2.666v-4.143c-4.374-.62-8-4.181-8-8.489h2.266c0 3.79 3.387 6.443 7.067 6.443 1.08 0 2.133-.24 3.08-.657l-2.213-2.097-.867.1c-2.213 0-4-1.692-4-3.789v-.91l-8-7.59 1.693-1.605z","fill":"#E53935"}})])
          )
        }
      }
    